module.exports = __webpack_public_path__ + "static/media/bd.a7978d3d.svg";